/* unplugin-vue-components disabled */import { render } from "./commonUpload.vue?vue&type=template&id=2ac169fb"
import script from "./commonUpload.vue?vue&type=script&lang=js"
export * from "./commonUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__